<template>
  <ul class="simple-menu">
    <li v-for="(item, index) in menu" :key="index">
      <router-link v-if="item.link" :to="item.link">{{ item.title }}</router-link>
      <span v-else>{{ item.title }}</span>
      <div v-if="item.children && item.children.length > 0" class="sub-menu">
        <template v-for="(subItem, subItemIndex) in item.children">
          <router-link v-if="!subItem.isExternalLink" :key="subItemIndex" :to="subItem.link">{{
            subItem.title
          }}</router-link>
          <a v-else :key="subItemIndex" :href="(isChinese ? '/cn' : '/en') + subItem.link">{{ subItem.title }}</a>
        </template>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  data() {
    return {
      menu: [
        {
          title: this.$t('mock_tests'),
          link: '/chooselevel',
        },
        {
          title: this.$t('support'),
          // link: '/feedback',
          children: [
            {
              title: this.$t('blog_and_faq'),
              link: '/index.html',
              isExternalLink: true,
            },
            {
              title: this.$t('contact'),
              link: '/feedback',
            },
          ],
        },
        {
          title: this.$t('more_menu'),
          // link: undefined,
          children: [
            {
              title: this.$t('for_institutions'),
              link: '/solutions',
            },
            {
              title: this.$t('about_us'),
              link: '/about',
            },
          ],
        },
      ],
    }
  },
  computed: {
    isChinese() {
      let local = this.$i18n.locale || localStorage.getItem('language')
      return local === 'zh'
    },
  }
}
</script>

<style lang="scss">
@import '@/styles/variables.scss';

.simple-menu {
  font-family: Calibri;
  list-style: none;
  display: flex;
  column-gap: 20px;

  & > li {
    height: 80px;
    position: relative;

    & > a.router-link-active {
      background: #16182f;
      text-decoration: none;
    }

    & > a,
    span {
      display: inline-block;
      height: 100%;
      line-height: 80px;
      color: #fff !important;
      font-size: 18px;
      padding: 0px 26px;
      transition: all 0.4s ease-in-out;
    }

    &:hover,
    &:has(.sub-menu:hover) {
      & > .sub-menu {
        display: block;
      }

      & > a,
      span {
        background: #16182f;
        text-decoration: none;
      }
    }

    &:has(.sub-menu > a.router-link-active) {
      & > a,
      span {
        background: #16182f;
        text-decoration: none;
      }
    }

    & > .sub-menu {
      position: absolute;
      padding: 20px 30px;
      top: 80px;
      left: 0;
      background-color: #121426;
      display: none;

      & > a {
        display: block;
        height: 40px;
        line-height: 40px;
        color: #fff !important;
        font-size: 18px;
        padding: 0px 0px;
        transition: all 0.4 ease-in-out;
        white-space: nowrap;

        &:hover {
          // background: darken(#2c2f46, 5%);
          color: $yellow !important;
          text-decoration: none;
        }

        &.router-link-active {
          color: $yellow !important;
        }
      }
    }
  }
}
</style>
